import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Notification, Loader, Button } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import axios from 'axios';
import { getToken } from '../../../auth/service/authService';
import {BackendUrl} from "../../../util/config";

export const InvitationAction: React.FC = () => {
    const [searchParams] = useSearchParams();
    const tokenParam = searchParams.get('token') || '';
    const action = searchParams.get('action') || 'accept'; // default to accept

    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const navigate = useNavigate();
    const userToken = getToken(); // Our usual "access token" from localStorage, etc.

    useEffect(() => {
        if (!tokenParam) {
            setLoading(false);
            setErrorMessage('No invitation token provided in the URL.');
            return;
        }

        if (!userToken) {
            // Not logged in? Redirect to /login with returnUrl back to this route
            // Save the full URL so we can come back after registration+verification
            localStorage.setItem('returnUrl', `/invitation-action?token=${tokenParam}&action=${action}`);

            navigate(`/login`);
            return;
        }

        // Otherwise, we have a user token and an invitation token, let's process
        handleInvitationAction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInvitationAction = async () => {
        setLoading(true);
        setSuccessMessage(null);
        setErrorMessage(null);

        try {
            // Choose correct endpoint
            let endpoint = BackendUrl +  `/invitations/accept?token=${tokenParam}`;
            if (action === 'reject') {
                endpoint = BackendUrl + `/invitations/reject?token=${tokenParam}`;
            }

            const response = await axios.post(endpoint, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setSuccessMessage(response.data);
            navigate("/")
            // Possibly navigate somewhere else on success
            // e.g., ; or keep them here to show success
        } catch (err: any) {
            console.error(err);
            setErrorMessage(err?.response?.data || 'Error processing invitation.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '1rem' }}>
            {loading && <Loader />}

            {successMessage && (
                <Notification
                    icon={<IconCheck size={18} />}
                    color="teal"
                    onClose={() => setSuccessMessage(null)}
                >
                    {successMessage}
                </Notification>
            )}

            {errorMessage && (
                <Notification
                    icon={<IconX size={18} />}
                    color="red"
                    onClose={() => setErrorMessage(null)}
                >
                    {errorMessage}
                </Notification>
            )}

            {/* Optional button to retry manually if needed */}
            {!loading && !successMessage && !errorMessage && (<>
                    <Button onClick={handleInvitationAction}>
                        {action === 'reject' ? 'Reject Invitation' : 'Accept Invitation'}
                    </Button>
                    <Button onClick={() => navigate("/")}>
                        Zurück
                    </Button>
            </>


            )}
        </div>
    );
};

